import React from 'react';

const Header = () => (
  <div className='remote-access-dialog__header'>
    <h4>Remote access</h4>
  </div>
);

export default Header;
